module.exports = __webpack_public_path__ + "img/home-danger.40191c3c.svg";